import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription, debounceTime, distinctUntilChanged } from 'rxjs';
import { RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { cloneData, isArray } from 'src/app/helper/class/utilityHelper';
import { ResponseData, whereField } from 'src/app/helper/interface/response';
import { AuthService } from 'src/app/helper/service/auth.service';
import { MasterApiService } from 'src/app/modules/master/service/master-api.service';
import { StaffApiService } from 'src/app/modules/staff/service/staff-api.service';
import { StudentApiService } from 'src/app/modules/student/service/student-api.service';
import { searchModal, searchModalResult, searchType } from 'src/app/shared/interface/modal-interface';

@Component({
  standalone: false,
  selector: 'app-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrl: './search-modal.component.scss'
})
export class SearchModalComponent {
  data: searchModal = {} as searchModal;
  loading: boolean = false;
  searchSub: Subscription = {} as Subscription;
  // public onClose: Subject<boolean> | any;
  searchControl: UntypedFormControl = {} as UntypedFormControl;
  resultData: searchModalResult[] = [];
  filterForm: UntypedFormGroup = new UntypedFormGroup({});
  filterCol: any = [];
  DATA_LOADING: any = {};
  FORM_SUPPORT_DATA: any = {};
  constructor(
    private dialogRef: DynamicDialogRef,
    private studentApi: StudentApiService,
    private staffApi: StaffApiService,
    private masterApi: MasterApiService,
    private auth: AuthService) { }


  public ngOnInit(): void {
    this.initForm();
  }

  setInput(data: any) {
    this.data = data;
    this.mapFormValue();
    this.searchData(null);
  }

  initForm() {
    const f: any = {};
    this.filterCol.forEach((a: any) => f[a.tblName] = new UntypedFormControl(""));
    this.filterForm = new UntypedFormGroup(f);
    this.searchControl = new UntypedFormControl();
    if (typeof this.searchSub.unsubscribe == "function") {
      this.searchSub?.unsubscribe();
    }
    this.searchSub = this.searchControl.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe(v => {
      if (v) {
        this.searchData(v);
      } else {
        this.resultData = [];
      }
    })
  }


  getFullData(tblName: any, cond = [], colName: any = '', apiFun: string = '') {
    if (tblName || apiFun) {
      this.DATA_LOADING[tblName] = true;
      let api: any;
      if (apiFun) {
        //@ts-ignore
        api = this.masterApi[apiFun](cond);
      } else {
        api = this.masterApi.getFullData(tblName, cond, false);
      }
      api.then((res: ResponseData | any) => {
        if (res.statusCode == RESPONSE_CODE.SUCCESS) {
          let re: any = res.result;
          this.data.whereField?.forEach((a: any) => {
            if (a.colName == tblName) {
              const val = isArray(a.value) ? a.value : [a.value];
              const cond = val.filter((a: any) => +a > 0);
              if (cond.length) {
                re = [];
                res.result.forEach((b: any) => {
                  if (a.value.includes(b.id)) {
                    re.push(b);
                  }
                })
              }
            }
          })
          this.FORM_SUPPORT_DATA[tblName] = re;
        } else {
          this.FORM_SUPPORT_DATA[tblName] = [];
        }
      }).finally(() => this.DATA_LOADING[tblName] = false)
    }
  }

  mapFormValue() {
    if (this.data.filterShow) {
      switch (this.data.type) {
        case 'Staff':
          this.filterCol = [{ tblName: 'school' }];
          break;
        case 'Student':
          this.filterCol = [{ tblName: 'school' }, { tblName: 'course' }];
          break;
      }
      this.filterCol.forEach((a: any) => this.getFullData(a.tblName, [], a.colName || a + 'Name'));
    }
    this.initForm();
  }


  removeUnderscore(t: string) {
    return t.replace(/_/g, " ");
  }

  mapToResultData(data: any, type: searchType = 'Staff') {
    const mapElement: searchModalResult | any = {};
    switch (this.data.type) {
      case 'Staff':
        mapElement.avatarPic = 'profile_img';
        mapElement.avatarTxt = 'name';
        mapElement.mutedText = 'staff_emp_id';
        mapElement.detail = 'name';
        mapElement.topEndText = 'mobile_no';
        mapElement.bottomEndText = 'schoolName';
        mapElement.bottomTopText = 'schoolName';
        mapElement.active = 'email_id';
        break;
      case 'Student':
        mapElement.avatarPic = 'profile_img_path';
        mapElement.avatarTxt = 'studentName';
        mapElement.mutedText = 'student_code';
        mapElement.detail = 'studentName';
        mapElement.topEndText = 'father_name';
        mapElement.bottomEndText = 'courseName';
        mapElement.bottomTopText = 'schoolName';
        mapElement.active = 'father_mobile_no';
        break;
    }
    const dt = ['avatarPic', 'avatarTxt', 'mutedText', 'topEndText', 'bottomEndText', 'bottomTopText', 'active', 'detail'];
    data.forEach((a: any) => {
      const s: any = {};
      dt.forEach(b => {
        const spiV = mapElement[b].split('+') || [];
        s[b] = (a[spiV[0]] || '') + (spiV[1] ? '   <span class="text-primary">' : '') + (spiV[1] ? a[spiV[1]] || '' + '</span>' : '');
      })
      this.resultData.push({ ...s, ...a });
    });
  }
  searchChange(value: any) {
    if (value.value) {
      this.searchData(value.value);
    } else {
      this.searchData(null)
    }

  }

  searchData(terms: string | null, initial: boolean = false) {
    this.loading = true;
    const where: whereField[] = this.data.whereField ? cloneData(this.data.whereField) : [];
    const school_fk_id = this.auth.getUser().school_fk_id
    if (school_fk_id) {
      where?.push({ value: school_fk_id, matchMode: "equals", colName: "school_fk_id" })
    }
    if (this.data.activeOnly) {
      if (isArray(where)) {
        where?.push({ colName: 'deleted_at', operation: 'AND', value: null })
      }
    }
    if (this.data.skipKey && this.data.skipData) {
      if (isArray(where)) {
        where?.push({ colName: this.data.skipKey, operation: 'AND', value: this.data.skipData })
      }
    }
    if (this.filterCol.length) {
      this.filterCol.forEach((a: any) => {
        const v = this.filterForm.value[a.tblName] || '';
        if (v) {
          const f = where.findIndex((c: any) => c.colName == a.tblName);
          if (f > -1) { where.splice(f, 1); }
          where?.push({ colName: a.tblName, value: v, operation: 'AND' });
        }
      })
    }
    let api: any;
    switch (this.data?.type) {
      case 'Staff':
        api = this.staffApi.search(terms, where);
        break;
      case 'Student':
        api = this.studentApi.search(terms, where);
        break;
      // case 'CHILD':
      //   api = this.childApi.search(terms, where);
      //   break;
      // case 'CHURCH':
      //   api = this.churchApi.search(terms, where);
      //   break;
      // case 'CHURCH_MEMBER':
      //   api = this.churchApi.searchMember(terms, where);
      //   break;
      // case 'ACCOUNT':
      //   api = this.accountApi.searchAccount(terms, where);
      //   break;
      //   case 'STAFF_PAYROLL':
      //   api = this.payrollApi.searchStaff(terms, where);
      //   break;
    }
    api.then((res: ResponseData | any) => {
      this.resultData = [];
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.mapToResultData(res.result);
      }
    }).finally(() => {
      this.loading = false;
    })
  }

  //   handleKeyDownEvent(event: KeyboardEvent) {
  //     if (event.keyCode === 8) { // Check if backspace key is pressed
  //         if (!this.searchControl.value) { // Check if search input is empty
  //             this.searchControl.reset(); // Reset the search control
  //         }
  //     }
  // }

  // handleInputEvent(event: Event) {
  //   const inputElement = event.target as HTMLInputElement;
  //   if (inputElement.value === '') { // Check if input field is empty
  //       this.searchControl.reset(); // Reset the search control
  //   }
  // }

  public onConfirm(data: any): void {
    this.dialogRef.close(data)
  }

  public onCancel(): void {
    this.dialogRef.close(false)
  }

  ngOnDestroy(): void {
    if (this.searchSub) {
      this.searchSub.unsubscribe();
    }
  }
}
